import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';
import ConditionalSpinner from 'components/ConditionalSpinner/ConditionalSpinner';
import Modal from 'components/Modal/modal';
import * as Ui from './BulkSelection.styles';

const BulkActionModal = ({
  actionLabel,
  actionVariant = 'primary',
  description,
  isOpen,
  isPending,
  onClose,
  onConfirm,
  title,
}) => {
  const { t } = useTranslation('app', { keyPrefix: 'bulkSelection' });

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      disabled={isPending}
      closeButton={!isPending}
      closeOnDocumentClick={!isPending}
      closeOnEscape={!isPending}
      header={{ title }}
      footer={() => (
        <Ui.ModalFooter>
          <Button type="button" variant="secondary" disabled={isPending} onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button
            type="button"
            variant={actionVariant}
            aria-busy={isPending}
            disabled={isPending}
            onClick={onConfirm}
          >
            <ConditionalSpinner showSpinner={isPending}>{actionLabel}</ConditionalSpinner>
          </Button>
        </Ui.ModalFooter>
      )}
    >
      <Ui.ModalMessage>{description}</Ui.ModalMessage>
    </Modal>
  );
};

BulkActionModal.propTypes = {
  actionLabel: PropTypes.string.isRequired,
  actionVariant: PropTypes.oneOf(['primary', 'danger']),
  description: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default BulkActionModal;
